var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('time',{attrs:{"datetime":_vm.iso,"title":_vm.absolute,"aria-label":_vm.absolute}},[_vm._v(_vm._s(_vm.relative))]):_c('span',[_vm._v("Fecha no disponible")])}
var staticRenderFns = []

export { render, staticRenderFns }